export const headerData = {
  id: 3,
  documentId: 'xghyr13hcelh9q9w28yeblbz',
  name: 'Acko homepage',
  logoUrls: true,
  darkThemeLogoUrl: 'https://acko-brand.ackoassets.com/brand/vector-svg/gradient/gradient-horizontal.svg',
  lightThemeLogoUrl: 'https://acko-brand.ackoassets.com/brand/vector-svg/gradient/gradient-horizontal.svg',
  showLoginStatus: true,
  createdAt: '2025-12-05T05:51:11.622Z',
  updatedAt: '2025-12-19T06:08:50.120Z',
  publishedAt: '2025-12-19T06:08:50.178Z',
  leftSideCategories: [
    {
      id: 46,
      documentId: 'vo2xjqagtujxdtm4kl7ccdsa',
      name: 'Products',
      title: 'Products',
      navMode: 'navDropdown',
      dropDownType: 'fullWidth',
      priority: 2,
      createdAt: '2025-12-05T05:44:06.132Z',
      updatedAt: '2026-05-15T07:34:58.591Z',
      publishedAt: '2026-05-15T07:34:58.703Z',
      bannerProps: {
        bannerType: 'travel-pass',
        eventProps: {},
        redirectionUrl: '/travel/domestic-pass/purchase/',
      },
      categorySections: [
        {
          id: 104,
          title: 'Car insurance',
          mobileTitle: 'Car',
          isExpandable: true,
          iconComponent: 'Car',
          sectionOptions: [
            {
              id: 1699,
              title: 'Car insurance',
              desktopUrl: '/car-insurance/',
              mobileUrl: '/car-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1700,
              title: 'Comprehensive car insurance',
              desktopUrl: '/car-insurance/comprehensive-car-insurance/',
              mobileUrl: '/car-insurance/comprehensive-car-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1701,
              title: 'Third party car insurance',
              desktopUrl: '/third-party-car-insurance/',
              mobileUrl: '/third-party-car-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1702,
              title: 'Own damage car insurance',
              desktopUrl: '/car-insurance/own-damage-insurance/',
              mobileUrl: '/car-insurance/own-damage-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1703,
              title: 'Zero depreciation car insurance',
              desktopUrl: '/car-insurance/zero-depreciation/',
              mobileUrl: '/car-insurance/zero-depreciation/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
          ],
          redirectionData: null,
        },
        {
          id: 105,
          title: 'Bike insurance',
          mobileTitle: 'Bike',
          isExpandable: true,
          iconComponent: 'Bike',
          sectionOptions: [
            {
              id: 1704,
              title: 'Bike insurance',
              desktopUrl: '/two-wheeler-insurance/',
              mobileUrl: '/two-wheeler-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1705,
              title: 'Scooter insurance',
              desktopUrl: '/scooter-insurance/',
              mobileUrl: '/scooter-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1706,
              title: 'Comprehensive bike insurance',
              desktopUrl: '/two-wheeler-insurance/comprehensive-bike-insurance/',
              mobileUrl: '/two-wheeler-insurance/comprehensive-bike-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1707,
              title: 'Third party bike insurance',
              desktopUrl: '/third-party-bike-insurance/',
              mobileUrl: '/third-party-bike-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
          ],
          redirectionData: null,
        },
        {
          id: 106,
          title: 'Health insurance',
          mobileTitle: 'Health',
          isExpandable: true,
          iconComponent: 'HealthCheckup',
          sectionOptions: [
            {
              id: 1708,
              title: 'Health insurance',
              desktopUrl: '/health-insurance/',
              mobileUrl: '/health-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1709,
              title: 'Health insurance Plans for Family',
              desktopUrl: '/health-insurance/health-insurance-plans-for-family/',
              mobileUrl: '/health-insurance/health-insurance-plans-for-family/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1710,
              title: 'Health Insurance Premium Calculator',
              desktopUrl: '/health-insurance/premium-calculator/',
              mobileUrl: '/health-insurance/premium-calculator/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1711,
              title: 'Health Insurance for Parents',
              desktopUrl: '/health-insurance/for-parents/',
              mobileUrl: '/health-insurance/for-parents/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1712,
              title: 'Senior Citizen Health Insurance',
              desktopUrl: '/health-insurance/senior-citizens/',
              mobileUrl: '/health-insurance/senior-citizens/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1713,
              title: 'Section 80D',
              desktopUrl: '/health-insurance/section80d-deductions/',
              mobileUrl: '/health-insurance/section80d-deductions/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1714,
              title: 'Arogya Sanjeevani Health Insurance',
              desktopUrl: '/gi/arogya-sanjeevani-health-insurance/',
              mobileUrl: '/gi/arogya-sanjeevani-health-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
          ],
          redirectionData: null,
        },
        {
          id: 107,
          title: 'Life insurance',
          mobileTitle: 'Life',
          isExpandable: true,
          iconComponent: 'Life',
          sectionOptions: [
            {
              id: 1715,
              title: 'Life insurance',
              desktopUrl: '/life-insurance/',
              mobileUrl: '/life-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1716,
              title: 'Term insurance',
              desktopUrl: '/life-insurance/term-insurance/',
              mobileUrl: '/life-insurance/term-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1717,
              title: 'Term Insurance Calculator',
              desktopUrl: '/calculators/term-insurance-calculator/',
              mobileUrl: '/calculators/term-insurance-calculator/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1718,
              title: '1 Crore Term Insurance',
              desktopUrl: '/life-insurance/1-crore-term-insurance/',
              mobileUrl: '/life-insurance/1-crore-term-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
          ],
          redirectionData: null,
        },
        {
          id: 108,
          title: 'Travel insurance',
          mobileTitle: 'Travel',
          isExpandable: true,
          iconComponent: 'Luggage',
          sectionOptions: [
            {
              id: 1719,
              title: 'Travel insurance',
              desktopUrl: '/travel-insurance/',
              mobileUrl: '/travel-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1720,
              title: 'International travel insurance',
              desktopUrl: '/international-travel-insurance/',
              mobileUrl: '/international-travel-insurance/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1721,
              title: 'Travel insurance for Schengen visa',
              desktopUrl: '/international-travel-insurance/schengen/',
              mobileUrl: '/international-travel-insurance/schengen/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1722,
              title: 'Travel Insurance for Dubai',
              desktopUrl: '/international-travel-insurance/dubai/',
              mobileUrl: '/international-travel-insurance/dubai/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1723,
              title: 'Travel Insurance for USA',
              desktopUrl: '/international-travel-insurance/usa/',
              mobileUrl: '/international-travel-insurance/usa/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1724,
              title: 'Travel Insurance for Thailand',
              desktopUrl: '/international-travel-insurance/thailand/',
              mobileUrl: '/international-travel-insurance/thailand/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
          ],
          redirectionData: null,
        },
        {
          id: 109,
          title: 'Other ACKO Products',
          mobileTitle: 'Other ACKO Products',
          isExpandable: true,
          iconComponent: null,
          sectionOptions: [
            {
              id: 1725,
              title: 'ACKO Airpass',
              desktopUrl: '/travel-insurance/domestic-airpass/',
              mobileUrl: '/travel-insurance/domestic-airpass/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
            {
              id: 1727,
              title: 'ACKO drive',
              desktopUrl: 'https://ackodrive.com/',
              mobileUrl: 'https://ackodrive.com/',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: null,
            },
          ],
          redirectionData: null,
        },
      ],
      redirectionData: null,
    },
    {
      id: 25,
      documentId: 'ygjx8q70kslpe7c1s8y545uf',
      name: 'Enterprise',
      title: 'Enterprise',
      navMode: 'redirect',
      dropDownType: 'fullWidth',
      priority: 6,
      createdAt: '2025-12-05T04:05:37.273Z',
      updatedAt: '2026-01-14T09:21:34.518Z',
      publishedAt: '2026-01-14T09:21:34.551Z',
      bannerProps: null,
      categorySections: [],
      redirectionData: {
        id: 646,
        title: 'Enterprise',
        desktopUrl: '/gi/enterprise/?utm_source=direct&utm_medium=homepage',
        mobileUrl: '/gi/enterprise/?utm_source=direct&utm_medium=homepage',
        openNewTab: true,
        forLoggedIn: true,
        forLoggedOut: true,
        lightBgImageUrl: null,
        darkBgImageUrl: null,
        iconComponent: null,
      },
    },
    {
      id: 26,
      documentId: 'd8jd7tduf7jo67tld6luofvq',
      name: 'Why ACKO?',
      title: 'Why ACKO?',
      navMode: 'navDropdown',
      dropDownType: 'fullWidth',
      priority: 7,
      createdAt: '2025-12-05T05:44:07.987Z',
      updatedAt: '2026-01-14T09:21:41.746Z',
      publishedAt: '2026-01-14T09:21:41.838Z',
      bannerProps: {
        bannerType: 'customer-stories',
        eventProps: {},
        redirectionUrl: '/reviews-testimonials/',
      },
      categorySections: [
        {
          id: 62,
          title: 'About Us',
          mobileTitle: 'About Us',
          isExpandable: false,
          iconComponent: null,
          sectionOptions: [],
          redirectionData: {
            id: 647,
            title: 'About Us',
            desktopUrl: '/about-us/',
            mobileUrl: '/about-us/',
            openNewTab: true,
            forLoggedIn: true,
            forLoggedOut: true,
            lightBgImageUrl: 'https://acko-cms.ackoassets.com/about_us_dark_dccd6630dc.webp',
            darkBgImageUrl: 'https://acko-cms.ackoassets.com/about_us_dark_dccd6630dc.webp',
            iconComponent: 'Details',
          },
        },
        {
          id: 63,
          title: 'Careers',
          mobileTitle: 'Careers',
          isExpandable: false,
          iconComponent: 'App',
          sectionOptions: [],
          redirectionData: {
            id: 648,
            title: 'Careers',
            desktopUrl: '/careers/',
            mobileUrl: '/careers/',
            openNewTab: true,
            forLoggedIn: true,
            forLoggedOut: true,
            lightBgImageUrl: 'https://acko-cms.ackoassets.com/how_acko_works_dark_aa694cfcb9.webp',
            darkBgImageUrl: 'https://acko-cms.ackoassets.com/how_acko_works_dark_aa694cfcb9.webp',
            iconComponent: 'App',
          },
        },
        {
          id: 64,
          title: 'Customer stories',
          mobileTitle: 'Customer stories',
          isExpandable: false,
          iconComponent: 'Message',
          sectionOptions: [],
          redirectionData: {
            id: 649,
            title: 'Blog',
            desktopUrl: '/reviews-testimonials/',
            mobileUrl: '/reviews-testimonials/',
            openNewTab: true,
            forLoggedIn: true,
            forLoggedOut: true,
            lightBgImageUrl: 'https://acko-cms.ackoassets.com/customer_stories_dark_1b7f7b7755.webp',
            darkBgImageUrl: 'https://acko-cms.ackoassets.com/customer_stories_dark_1b7f7b7755.webp',
            iconComponent: 'Message',
          },
        },
      ],
      redirectionData: null,
    },
    {
      id: 27,
      documentId: 'qvao1jo5xv7eufxqucczv5gb',
      name: 'Support',
      title: 'Support',
      navMode: 'redirect',
      dropDownType: 'fullWidth',
      priority: 5,
      createdAt: '2025-12-05T05:44:07.038Z',
      updatedAt: '2026-01-14T09:21:46.707Z',
      publishedAt: '2026-01-14T09:21:46.753Z',
      bannerProps: null,
      categorySections: [],
      redirectionData: {
        id: 650,
        title: 'Support',
        desktopUrl: '/contact-us/',
        mobileUrl: '/contact-us/',
        openNewTab: true,
        forLoggedIn: true,
        forLoggedOut: true,
        lightBgImageUrl: null,
        darkBgImageUrl: null,
        iconComponent: null,
      },
    },
  ],
  rightSideCategories: [
    {
      id: 28,
      documentId: 'tii13edenkhewn9xnz83c1ky',
      name: 'Renewals',
      title: 'Renewals',
      navMode: 'navDropdown',
      dropDownType: 'contentWidth',
      priority: 3,
      createdAt: '2025-12-05T05:44:07.136Z',
      updatedAt: '2026-01-14T09:21:52.863Z',
      publishedAt: '2026-01-14T09:21:52.963Z',
      bannerProps: null,
      categorySections: [
        {
          id: 65,
          title: 'New to ACKO?',
          mobileTitle: null,
          isExpandable: true,
          iconComponent: null,
          sectionOptions: [
            {
              id: 651,
              title: 'Renew health insurance',
              desktopUrl: '/myaccount',
              mobileUrl: '/myaccount',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: 'https://acko-cms.ackoassets.com/health_insurance_dark_07867bf6b3.webp',
              darkBgImageUrl: 'https://acko-cms.ackoassets.com/health_insurance_dark_07867bf6b3.webp',
              iconComponent: 'HealthCheckup',
            },
            {
              id: 652,
              title: 'Renew car insurance',
              desktopUrl: '/myaccount',
              mobileUrl: '/myaccount',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: 'https://acko-cms.ackoassets.com/car_insurance_dark_e4818cf77a.webp',
              darkBgImageUrl: 'https://acko-cms.ackoassets.com/car_insurance_dark_e4818cf77a.webp',
              iconComponent: 'Car',
            },
            {
              id: 653,
              title: 'Renew bike insurance',
              desktopUrl: '/myaccount',
              mobileUrl: '/myaccount',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: 'https://acko-cms.ackoassets.com/bike_insurance_dark_14892f8fc3.webp',
              darkBgImageUrl: 'https://acko-cms.ackoassets.com/bike_insurance_dark_14892f8fc3.webp',
              iconComponent: 'Bike',
            },
            {
              id: 654,
              title: 'Renew life insurance',
              desktopUrl: '/myaccount',
              mobileUrl: '/myaccount',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: true,
              lightBgImageUrl: 'https://acko-cms.ackoassets.com/life_insurance_dark_1cc490ac3e.webp',
              darkBgImageUrl: 'https://acko-cms.ackoassets.com/life_insurance_dark_1cc490ac3e.webp',
              iconComponent: 'Life',
            },
          ],
          redirectionData: null,
        },
        {
          id: 66,
          title: 'Existing ACKO Customer',
          mobileTitle: null,
          isExpandable: true,
          iconComponent: null,
          sectionOptions: [
            {
              id: 655,
              title: 'Login and renew policy',
              desktopUrl:
                '/authn/v1/signin?client_id=acko_webapp&redirect_uri=https%3A%2F%2Fwww.acko.com%2Fplatform%2Fauth%2Ftoken%2Facko_webapp&response_type=code&identity_type=d2c&scope=offline_access&realm=acko',
              mobileUrl:
                '/authn/v1/signin?client_id=acko_webapp&redirect_uri=https%3A%2F%2Fwww.acko.com%2Fplatform%2Fauth%2Ftoken%2Facko_webapp&response_type=code&identity_type=d2c&scope=offline_access&realm=acko',
              openNewTab: true,
              forLoggedIn: false,
              forLoggedOut: true,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: 'Login',
            },
            {
              id: 656,
              title: 'Renew Policy',
              desktopUrl: '/myaccount',
              mobileUrl: '/myaccount',
              openNewTab: true,
              forLoggedIn: true,
              forLoggedOut: false,
              lightBgImageUrl: null,
              darkBgImageUrl: null,
              iconComponent: 'Login',
            },
          ],
          redirectionData: null,
        },
      ],
      redirectionData: null,
    },
    {
      id: 29,
      documentId: 'l4n7qtthd16lahbg5fd6x2hc',
      name: 'Claims',
      title: 'Claims',
      navMode: 'outlined-button',
      dropDownType: 'contentWidth',
      priority: 4,
      createdAt: '2025-12-05T05:44:05.657Z',
      updatedAt: '2026-01-14T09:21:59.499Z',
      publishedAt: '2026-01-14T09:21:59.557Z',
      bannerProps: null,
      categorySections: [
        {
          id: 67,
          title: 'File a claim',
          mobileTitle: 'File a new claim',
          isExpandable: false,
          iconComponent: null,
          sectionOptions: [],
          redirectionData: {
            id: 657,
            title: 'File a claim',
            desktopUrl: '/myaccount',
            mobileUrl: '/myaccount',
            openNewTab: true,
            forLoggedIn: true,
            forLoggedOut: true,
            lightBgImageUrl: 'https://acko-cms.ackoassets.com/File_new_claim_new_dark_4a09d138d1.webp',
            darkBgImageUrl: 'https://acko-cms.ackoassets.com/File_new_claim_new_dark_4a09d138d1.webp',
            iconComponent: 'Claim',
          },
        },
        {
          id: 68,
          title: 'Track a claim',
          mobileTitle: 'Track existing claim',
          isExpandable: false,
          iconComponent: null,
          sectionOptions: [],
          redirectionData: {
            id: 658,
            title: 'Track a claim',
            desktopUrl: '/myaccount',
            mobileUrl: '/myaccount',
            openNewTab: true,
            forLoggedIn: true,
            forLoggedOut: true,
            lightBgImageUrl: 'https://acko-cms.ackoassets.com/Track_claim_new_dark_6fd86ac08a.webp',
            darkBgImageUrl: 'https://acko-cms.ackoassets.com/Track_claim_new_dark_6fd86ac08a.webp',
            iconComponent: 'Tracking',
          },
        },
      ],
      redirectionData: null,
    },
    {
      id: 2,
      documentId: 'k8nk7mx0tp09xagglnh67f0i',
      name: 'My policies',
      title: 'My policies',
      navMode: 'redirect',
      dropDownType: 'fullWidth',
      priority: 1,
      createdAt: '2025-12-05T04:01:28.445Z',
      updatedAt: '2025-12-05T04:01:28.445Z',
      publishedAt: '2025-12-05T04:01:28.482Z',
      bannerProps: null,
      categorySections: [],
      redirectionData: {
        id: 2,
        title: 'My policies',
        desktopUrl: null,
        mobileUrl: '/myaccount',
        openNewTab: true,
        forLoggedIn: true,
        forLoggedOut: false,
        lightBgImageUrl: null,
        darkBgImageUrl: null,
        iconComponent: null,
      },
    },
  ],
}
